import React from 'react'
import { StyledChatItem } from './ChatItem.style';
import Image from '@/Components/atoms/Image';
import { IProfileChatDto } from '@/Models/Chat';
import { getImageUrlByPath } from '@/Services/Image';
import { useTranslation } from 'next-i18next';
import { colors } from '@/styles/colors';

type Props = {
  item: IProfileChatDto;
  onSelect?: (id: number) => void;
}

const ChatBuyItem = ({ item, onSelect }: Props) => {
  const { t } = useTranslation();

  const onClick = () => {
    onSelect && onSelect(item.id);
  }



  return (
    <StyledChatItem className='chat-item' onClick={onClick}>
      <div className='chat-item__inner'>
        <div className='chat-item__img-wrapper'>
          {
            item.avatarPath
            ? (
              <Image className='chat-item__img' src={getImageUrlByPath(item.avatarPath, 200, 200)} alt='' />
            ) : (
              <div style={{ fontSize: 24, fontWeight: 500, backgroundColor: colors.lightPrimary, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                { item.firstName.slice(0, 1) }
              </div>
            )
          }
        </div>
        <div className='chat-item__text-wrapper'>
          <div className='chat-item__title-wrapper'>
            <h5 className='chat-item__title'>{item.firstName}</h5>
          </div>
          <div className="chat-item__description-wrapper">
            <p className='chat-item__description'>
              { t('archived_chat_product_title', { key: item.productName }) }
            </p>
          </div>
        </div>
      </div>
    </StyledChatItem>
  )
}

export default ChatBuyItem;
